var map = {
	"./FamilyDay.png": 21794,
	"./Happy50thBirthdayWishes.png": 64167,
	"./HappyBirthday.png": 85377,
	"./HappyChristmas.png": 56200,
	"./HappyChristmasAndNewYear.png": 49500,
	"./HappyChristmasAndNewYear2026.png": 53962,
	"./HappyChristmasAndNewYearDefault.png": 37321,
	"./HappyChristmasWelcome.png": 93630,
	"./HappyFathersDay.png": 20363,
	"./HappyLoversDay.png": 19461,
	"./HappyLoversDayBird.png": 44700,
	"./videoframe12464.png": 6957
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98369;